import React, { useEffect, useState } from 'react';
import Character from "./Character";
import { Avatar, makeStyles, Theme, createStyles, Typography, Divider, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { SpriteDefine } from './SpriteManager';
import { Rating } from '@material-ui/lab';
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../Lambda";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: "auto",
            width: "calc(min(90vw, 512px))",
        },
        media: {
            height: 0,
            width: "100%",
            paddingTop: '56.25%', // 16:9
        },
        dummy: {
            backgroundColor: "#aaa",
            width: "100%",
            height: "100%",
        },
        label: {
            padding: theme.spacing(1),
            display: "flex",
            alignItems: "center",
        },
        text: {
            marginLeft: theme.spacing(1),
        },
        avatar: {
            backgroundColor: red[500],
        },
    })
);


interface Props {
    open: boolean
    onClose?: ()=>void | undefined
    member?: Lambda.MemberType | undefined
    sprite?: SpriteDefine | undefined
}

function CharDialog(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const [member, setMember] = useState<Lambda.MemberType | undefined>()
    useEffect(()=>{
        props.member && setMember(props.member)
    },[props.member])

    return member?.join ? (
        <Dialog 
            className={classes.root} 
            open={props.open}
            onClose={()=>props.onClose?.()}
        >
            <DialogTitle>
                <span className={classes.label}>
                    <Avatar
                        className={classes.avatar}
                        src={member?.icon?.get}
                    >
                        {member.name.slice(0, 1)}
                    </Avatar>
                    <span className={classes.text}>{member.name}</span>
                </span>
            </DialogTitle>

            <DialogContent >
                <Character
                    sprite={props.sprite}
                    character={member.avatar}
                />
            </DialogContent >

            <DialogContent >
                <Typography variant="body2" >{t("label.character.status")}</Typography>
                <Typography>
                    {t(`status.${member.status}`)}
                </Typography>                                    
                    <Typography variant="body2" >{t("label.character.busyness")}</Typography>
                <Rating
                    value={member.busyness}
                    precision={0.5}
                    readOnly
                />
                <Typography variant="body2" >{t("label.character.comment")}</Typography>
                <Typography>
                    {member.comment}
                </Typography>     
                <Divider />
                {
                    /*
                    props.room?.fields?.map(field=>(
                        <div>
                            <Typography variant="body2" >{field.label}</Typography>
                            <Typography>
                                {props.member?.attributes[field.id]}
                            </Typography>  
                        </div>
                    ))
                    */
                }
            </DialogContent >
        </Dialog>
    ) : (        
        <Dialog 
            className={classes.root} 
            open={props.open}
            onClose={()=>props.onClose?.()}
        >
            <DialogTitle className={classes.label}>
                <span className={classes.label}>
                    <Avatar
                        className={classes.avatar}
                    >
                    </Avatar>
                    <span className={classes.text}>{t("status.invite")}</span>
                </span>
            </DialogTitle>

            <DialogContent >
                <div className={classes.dummy} />
            </DialogContent >
        </Dialog>
    )
}
export default CharDialog